/* __next_internal_client_entry_do_not_use__ LinkStyles,TextAction,onClickTextAction auto */ import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { trackSlateDesignSystemUiButtonClickClick } from "@faire/web-api--source/events/slateDesignSystem/click/uiButtonClick";
import * as React from "react";
import styled, { css } from "styled-components";
import { Color } from "../../slate/Color";
import { Spacer } from "../../slate/spacing";
import { themeOrDefault } from "../../slate/Theme";
import { TypographyStyles } from "../Typography";
var animation = "all 0.2s ease-in-out";
export var LinkStyles = function(param) {
    var animate = param.animate, color = param.color, hoverColor = param.hoverColor, disabled = param.disabled;
    var _ref, _ref1;
    return css([
        "color:",
        ";",
        ";",
        ";"
    ], color, disabled ? "" : css([
        "cursor:pointer;&:hover{color:",
        ";}"
    ], (_ref = hoverColor !== null && hoverColor !== void 0 ? hoverColor : color) !== null && _ref !== void 0 ? _ref : "inherit"), animate ? css([
        "transition:",
        ';position:relative;&:before,&:after{left:0;content:"";position:absolute;bottom:0;width:',
        ";height:1px;transition:",
        ";transition-duration:0.25s;background:",
        ";opacity:",
        ";}",
        ";"
    ], animation, animate === "in" ? "0px" : "100%", animation, color !== null && color !== void 0 ? color : "currentColor", animate === "in" ? "0" : "1", disabled ? "" : css([
        "&:hover{",
        "}&:hover:before,&:hover:after{background:",
        ";width:",
        ";opacity:",
        ";box-shadow:0 0 1px 0 white inset;}"
    ], hoverColor ? css([
        "color:",
        ";"
    ], hoverColor) : "", (_ref1 = hoverColor !== null && hoverColor !== void 0 ? hoverColor : color) !== null && _ref1 !== void 0 ? _ref1 : "currentColor", animate === "in" ? "100%" : "0px", animate === "in" ? "1" : "0")) : css([
        "text-decoration:underline;text-decoration-thickness:1px;text-decoration-color:",
        ";",
        ";"
    ], color !== null && color !== void 0 ? color : "currentColor", disabled ? "" : css([
        "&:active,&:hover,&:focus{",
        "}"
    ], hoverColor ? css([
        "text-decoration-color:",
        ";"
    ], hoverColor) : "")));
};
var getAnimation = function(animate) {
    if (animate === true) {
        // default to 'in'
        return "in";
    } else if (typeof animate === "string") {
        return animate;
    } else {
        return false;
    }
};
var hoverColorOrDefault = function(color) {
    return Color[color] || color;
};
var IconWrapper = styled.div.withConfig({
    componentId: "sc-ae4cee8e-0"
})([
    "font-size:16px;height:",
    ";display:flex;align-items:center;color:",
    ";"
], function(props) {
    var _props_theme_fonts_sansSerif_p, _props_theme_fonts_sansSerif, _props_theme_fonts, _props_theme;
    var _props_theme_fonts_sansSerif_p_lineHeight;
    return (_props_theme_fonts_sansSerif_p_lineHeight = (_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : (_props_theme_fonts = _props_theme.fonts) === null || _props_theme_fonts === void 0 ? void 0 : (_props_theme_fonts_sansSerif = _props_theme_fonts.sansSerif) === null || _props_theme_fonts_sansSerif === void 0 ? void 0 : (_props_theme_fonts_sansSerif_p = _props_theme_fonts_sansSerif.p) === null || _props_theme_fonts_sansSerif_p === void 0 ? void 0 : _props_theme_fonts_sansSerif_p.lineHeight) !== null && _props_theme_fonts_sansSerif_p_lineHeight !== void 0 ? _props_theme_fonts_sansSerif_p_lineHeight : "20px";
}, function(param) {
    var $disabled = param.$disabled, color = param.color, theme = param.theme;
    var buttons = themeOrDefault(theme).buttons;
    if (color === "primary" || color === "secondary") {
        color = Core.text.default;
    }
    return $disabled ? Core.text.subdued : color !== null && color !== void 0 ? color : buttons.secondary.text.color;
});
var TextActionChildrenWrapper = styled.span.withConfig({
    componentId: "sc-ae4cee8e-1"
})([
    "",
    " ",
    ";color:",
    ";"
], function(props) {
    var _props_$typographyStyles;
    return TypographyStyles((_props_$typographyStyles = props.$typographyStyles) !== null && _props_$typographyStyles !== void 0 ? _props_$typographyStyles : {
        p: true
    }, props.theme);
}, function(param) {
    var $animate = param.$animate, $color = param.$color, $hoverColor = param.$hoverColor, $disabled = param.$disabled;
    var _ref;
    return LinkStyles({
        animate: getAnimation($animate),
        hoverColor: hoverColorOrDefault((_ref = $hoverColor !== null && $hoverColor !== void 0 ? $hoverColor : $color) !== null && _ref !== void 0 ? _ref : Core.text.default),
        disabled: $disabled
    });
}, function(param) {
    var $disabled = param.$disabled, $color = param.$color, theme = param.theme;
    var buttons = themeOrDefault(theme).buttons;
    return $disabled ? Core.text.subdued : $color !== null && $color !== void 0 ? $color : buttons.secondary.text.color;
});
var SpanRow = styled.span.withConfig({
    componentId: "sc-ae4cee8e-2"
})([
    "display:flex;white-space:nowrap;"
]);
export var TextAction = function(_param) {
    var children = _param.children, icon = _param.icon, props = _object_without_properties(_param, [
        "children",
        "icon"
    ]);
    return /*#__PURE__*/ _jsxs(SpanRow, {
        children: [
            /*#__PURE__*/ _jsx(TextActionChildrenWrapper, {
                $animate: props.animate,
                $color: props.color,
                $hoverColor: props.hoverColor,
                $disabled: props.disabled,
                $typographyStyles: props.typographyStyles,
                "data-test-id": "tertiary-text",
                children: children
            }),
            icon ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: 4
                    }),
                    /*#__PURE__*/ _jsx(IconWrapper, {
                        $disabled: props.disabled,
                        color: props.color,
                        children: icon
                    })
                ]
            }) : null
        ]
    });
};
export var onClickTextAction = function(onClick, postEventButtonId) {
    return function(e) {
        if (postEventButtonId) {
            trackSlateDesignSystemUiButtonClickClick(postEventButtonId);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
};
